module.exports = __webpack_public_path__ + "static/media/american-express.753d3c63.png";